import { Card, Button, Image, Row, Col, Container } from "react-bootstrap";
import BackArrow from "../../../components/backArrow";
import { useNavigate, Link, useLocation } from "react-router-dom";

const mockPeople = [
  { name: "Alex John", img: "https://i.pravatar.cc/150?img=11" },
  { name: "Ammanda John", img: "https://i.pravatar.cc/150?img=12" },
  { name: "Rossie Feat", img: "https://i.pravatar.cc/150?img=13" },
  { name: "John Doe", img: "https://i.pravatar.cc/150?img=14" },

  { name: "Alex John", img: "https://i.pravatar.cc/150?img=11" },
  { name: "Ammanda John", img: "https://i.pravatar.cc/150?img=12" },
  { name: "Rossie Feat", img: "https://i.pravatar.cc/150?img=13" },
  { name: "John Doe", img: "https://i.pravatar.cc/150?img=14" },


  { name: "Alex John", img: "https://i.pravatar.cc/150?img=11" },
  { name: "Ammanda John", img: "https://i.pravatar.cc/150?img=12" },
];
  
const HorizontalScrollList = ({ title }) => (
  <Card className="mb-3 p-1 shadow bg-white">
    <Card.Header className="d-flex justify-content-between align-items-center bg-white border-0 ">
      <p className="mb-0">
        <strong>{title}</strong> <br></br>
        <span style={{ fontSize: 11, color: "grey" }}>
          Raw material suppliers
        </span>
      </p>
      <Link to="/connected-profile" style={{ fontSize: 12 }}>
        View all
      </Link>
    </Card.Header>
    <Card.Body>
      <Row>
        {mockPeople.map((person, idx) => (
          <Col lg="2" md="2" sm="2" xs="2" key={idx} className="text-center me-3">
            <Image src={person.img} roundedCircle width={50} height={50} />
            <div style={{ fontSize: 11 }}>{person.name}</div>
          </Col>
        ))}
      </Row>
    </Card.Body>
  </Card>
);

const ProfileSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <Container fluid className="ps-3 bg-muted">
      {location && location.pathname === "/seekar-profile" ? "" : <BackArrow />}

      <Card className="mb-4">
        <Card.Img
          variant="top"
          src="https://images.unsplash.com/photo-1503264116251-35a269479413"
          style={{ height: 200, objectFit: "cover" }}
        />
        <Card.Body className="text-left bg-muted">
          <Row>
            <Col xl="3" lg="3" md="2">
              {" "}
              <Image
                src="https://i.pravatar.cc/100"
                roundedCircle
                className="mb-2"
                style={{ marginTop: -50, border: "3px solid white" }}
              />
            </Col>

            <Col xl="5" lg="5" md="6">
              {" "}
              <h5>David Paul</h5>
              <p className="mb-0" style={{ fontSize: 14, color: "#555" }}>
                Investor
              </p>
              <p className="mb-0" style={{ fontSize: 12, color: "#777" }}>
                Wallet ID: 123456789987654321
              </p>
            </Col>

            <Col
              lg="4"
              md="4"
              className="d-flex justify-content-end flex-column gap-2"
            >
              {location && location.pathname === "/seekar-profile" ? (
                <>
                  {" "}
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() =>
                      navigate("/listed-programs")
                    }
                  >
                    View listed projects
                  </Button>
                  <Button
                    size="sm"
                    variant="primary"
                    onClick={() =>
                      navigate("/post-seekar-form")
                    }
                  >
                    Request for New project
                  </Button>{" "}
                </>
              ) : (
                ""
              )}

              <Button
                size="sm"
                variant="primary"
                onClick={() =>
                  navigate(`/connection-request/${123456789987654321}`)
                }
              >
                Connection Requests
              </Button>
            </Col>
          </Row>
        </Card.Body>

        <Row className="p-4 pt-0  pb-2">
          <HorizontalScrollList title="Investors" />
          <HorizontalScrollList title="Investment seekers" />
        </Row>
      </Card>
    </Container>
  );
};

export default ProfileSection;
